import { User } from '../../../types';

export const buildUserChannelName = (userId: User['id']): string =>
  userId ? `user.${userId}` : '';
